import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TextKeys } from '../../core/i18n/text-keys';
import { UntypedFormControl } from '@angular/forms';
import { BadgeQuery } from '../../core/state-mangement/badge/badge.query';
import * as moment from 'moment';

@Component({
  selector: 'app-ask-for-autogehen-time',
  templateUrl: './ask-for-autogehen-time.component.html',
  styleUrls: ['./ask-for-autogehen-time.component.scss'],
})
export class AskForAutogehenTimeComponent implements OnInit {
  @Output() cancelEvent = new EventEmitter();
  @Output() createGehenEvent = new EventEmitter<Date>();
  @Input() selectedDate: Date;
  timeInput = new UntypedFormControl();
  texts = TextKeys;

  constructor(private badgeQuery: BadgeQuery) {}

  ngOnInit() {
    const lastTime = moment(
      this.badgeQuery.getValue()?.data?.dayInfo?.currentTimeEntry?.uzeit
    );
    this.timeInput.setValue(lastTime.format('HH:mm'));
  }

  emitCancelEvent() {
    this.cancelEvent.emit();
  }

  setVisum() {
    this.createGehenEvent.emit(this.timeInput.value);
  }
}
